import React, { Component } from 'react';
import { Row, Col, Card, Container } from 'react-bootstrap';
import * as Cookies from "es-cookie";
import CreateTestSection from './create_lec_paper/CreateTestSection';
import ManageLecPaperSection from './manage_lec_paper/ManageLecPaperSection';
import ExamsSummarySection from './summary_section/ExamsSummarySection';
import './_quiz.scss';

class LecPaperHomeSection extends Component {
    constructor(props) {
        super(props)
        this.state = {
            blockType: "createExam"
        }
    }

    handleBlockViewSelect(val) {
        this.setState({
            blockType: val
        })
    }



    render() {
        
        return (
            <section className='quiz_section'>
                <Container fluid>
                    <Row>
                        <Col sm={4} className='mt-3 mb-1'>
                        <Card className={this.state.blockType == "createExam" ? "active block_view" : " block_view"} onClick={() => this.handleBlockViewSelect("createExam")}>
                            <Card.Body>
                                <h5 className="text-center color_blue"><img className="mr-2"  src={require('../../../images/create_quiz_blue.png')}  alt="Create_Quiz"/> <span className='title_alignment'>Create Test</span></h5>
                                <Card.Text className='mt-4 f-16'>
                                    For a given topics in a subject create 30 Mins Test, publish the Test to selected sections in a class.
                                </Card.Text>
                                
                            </Card.Body>
                            </Card>
                        </Col>
                        <Col sm={4} className='mt-3 mb-1'>
                            <Card className={this.state.blockType == "scheduledQuiz" ? "active block_view" : " block_view"} onClick={() => this.handleBlockViewSelect("scheduledQuiz")}>
                                <Card.Body>
                                    <h5 className="text-center color_blue"><img className="mr-2"  src={require('../../../images/manage_quiz_blue.png')}  alt="Manage_Quiz"/> <span className='title_alignment'>Manage Test</span></h5>
                                    <Card.Text className='mt-4 f-16'>
                                        Already Created Draft, Scheduled, Live Exams Management. Draft Exams can be scheduled.
                                    </Card.Text>
                                    
                                </Card.Body>
                            </Card>

                        </Col>

                        <Col sm={4} className='mt-3 mb-1'>
                            <Card className={this.state.blockType == "summarySection" ? "active block_view" : " block_view"} onClick={() => this.handleBlockViewSelect("summarySection")}>
                                <Card.Body>
                                    <h5 className="text-center color_blue"><img className="mr-2"  src={require('../../../images/quiz_summary_blue.png')}  alt="Summary_Section"/> <span className='title_alignment'>Exams Summary</span></h5>
                                    <Card.Text className='mt-4 f-16'>
                                    Already completed exams summary for each <br/>exam wise.
                                    </Card.Text>
                                    
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                   
                        {
                            this.state.blockType === "createExam"
                                ? <CreateTestSection  globals={this.props.globals} getExamModelTypes ={this.props.getExamModelTypes} />
                                : this.state.blockType === "scheduledQuiz"
                                ? <ManageLecPaperSection globals={this.props.globals} savedPapers={this.props.savedPapers}  getExamModelTypes ={this.props.getExamModelTypes} getLecScheduledPaper={this.props.getLecScheduledPaper}/>
                                 : this.state.blockType === "summarySection"
                                 ? <ExamsSummarySection globals={this.props.globals} getExamModelTypes ={this.props.getExamModelTypes} getEamcetCourseExams={this.props.getEamcetCourseExams}/> 
                                 
                                 :
                                 
                                 ""                               
                        }

                </Container>
            </section>
        )
    }
}

export default LecPaperHomeSection;
